module.exports = __webpack_public_path__ + "static/media/location-maps-letter-i.2961f1d8.png";